'use client';
import Image from '@repo/ui/src/components/Image/New';
import { ToutContent } from '@repo/ui/src/components/ToutContent';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { ToutContentProps } from '@repo/ui/src/types/toutContent';
import { ImageProps } from '@repo/ui/src/types/image';
import ProductCard from '@components/Cards/ProductCard';
import { classNames } from '@repo/ui/src/utils/classNames';
import { ProductModelProps } from '@typings/product';
import useProducts from '@hooks/product/useProducts';

interface Props {
  toutContent?: ToutContentProps;
  backgroundImage?: ImageProps;
  saleText?: string;
  newText?: string;
  _testID?: string;
  _data: Array<ProductModelProps>;
}

const gradientAlignments = {
  left: 'tw-bg-gradient-to-tl',
  right: 'tw-bg-gradient-to-tr',
};

const RelatedProductGrid = ({
  toutContent,
  backgroundImage,
  saleText,
  newText,
  _data,
  _testID,
}: Props) => {
  const { products } = useProducts(_data);

  const backgroundImageUrl = backgroundImage?.image ? buildImageSrc(backgroundImage, 400) : '';

  return (
    <div
      data-test-id={`related_product_grid_${_testID}`}
      className="tw-grid md:tw-grid-cols-[minmax(0,1fr),minmax(0,2fr)] lg:tw-grid-cols-[minmax(0,1fr),minmax(0,3fr)]"
    >
      <div className={backgroundImage ? 'tw-relative' : 'tw-bg-black'}>
        {backgroundImage && (
          <Image
            src={backgroundImageUrl}
            alt=""
            fill
            className="-tw-z-10 tw-absolute tw-object-cover tw-min-h-96"
          />
        )}
        <div
          className={classNames(
            'tw-h-full tw-min-h-[inherit] tw-from-transparent tw-to-[rgba(0,0,0,0.7)] tw-to-90% tw-from-0%',
            gradientAlignments[(toutContent?.align ?? '') as keyof typeof gradientAlignments] ??
              'tw-bg-gradient-to-t',
          )}
        >
          <ToutContent
            dark
            headingStyleVariant="h2"
            align={toutContent?.align ?? 'left'}
            {...toutContent}
            className="tw-p-6 sm:tw-p-gutterLG"
          />
        </div>
      </div>
      <ul className="tw-list-none tw-grid sm:tw-grid-cols-2 lg:tw-grid-cols-3 tw-pl-0">
        {products?.slice(0, 6).map((product, index) => (
          <li
            key={product?.sku}
            className="[&:nth-child(n+5)]:tw-hidden lg:[&:nth-child(n+5)]:tw-block tw-border tw-border-warm-200"
          >
            <ProductCard
              product={product}
              saleText={saleText}
              newText={newText}
              _testID={_testID}
              index={index}
              listName={toutContent?.heading}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default RelatedProductGrid;
